export default [
  {
    id: 'stripe',
    allow_reusable_use: true,
    allow_single_use: true,
    currencies: ['USD', 'MXN'],
    description: 'Stripe es la solución preferida de Piriod para procesar pagos globales. Mejora la experiencia de pago de tus clientes con las soluciones para pagos únicos o recurrentes de Stripe.',
    guide: '/docs/integrations-stripe',
    name: 'Stripe',
    placeholder: '',
    warning: ''
  },
  {
    id: 'paypal',
    allow_reusable_use: false,
    allow_single_use: true,
    currencies: ['USD', 'MXN'],
    description: 'PayPal permite a los consumidores pagar mediante su billetera digital. Los clientes son redirigidos a la página de pago de PayPal para iniciar sesión y aprobar los cargos. PayPal es ideal para la recaudación de pagos en USD.',
    guide: '/docs/integrations-paypal',
    name: 'PayPal',
    placeholder: '',
    warning: ''
  },
  {
    id: 'oneclick',
    allow_reusable_use: true,
    allow_single_use: false,
    currencies: ['CLP'],
    description: 'OneClick permite a los consumidores pagar mediante la asociación de tarjetas de crédito. Los clientes son redirigidos a la página de pago de OneClick para autorizar sus tarjetas y posteriormente Piriod hace los cargos periódicos.',
    guide: '/docs/integrations-oneclick',
    name: 'OneClick Transbank',
    placeholder: '5970XXXXXXXX',
    warning: 'Tu Código de Comercio debe estar enlazado al Código de Comercio de Piriod (597036088419) en Transbank OneClick.'
  },
  {
    id: 'webpay',
    allow_reusable_use: false,
    allow_single_use: true,
    currencies: ['CLP'],
    description: 'WebPay permite a los consumidores pagar mediante, tarjetas de crédito y débito desde su cuenta bancaria.Los clientes son redirigidos a la página de pago de WebPay para iniciar sesión y aprobar pagos.',
    guide: '/docs/integrations-webpay',
    name: 'WebPay Transbank',
    placeholder: '5970XXXXXXXX',
    warning: 'Tu Código de Comercio debe estar enlazado al Código de Comercio de Piriod (597035838481) en Transbank WebPay.'
  },
  {
    id: 'khipu',
    allow_reusable_use: false,
    allow_single_use: true,
    currencies: ['CLP'],
    description: 'Khipu permite a los consumidores Chilenos pagar directamente mediante transferencia en línea desde su cuenta bancaria. Los clientes son redirigidos a la página de pago de Khipu para iniciar sesión y aprobar pagos.',
    guide: '/docs/integrations-khipu',
    name: 'Khipu',
    placeholder: '',
    warning: ''
  },
  {
    id: 'mercadopago',
    allow_reusable_use: false,
    allow_single_use: true,
    currencies: ['CLP'],
    description: 'Mercado Pago permite a los consumidores pagar mediante sus tarjetas de crédito. Acepta tarjetas sin pagar gastos fijos a través del líder en procesamiento de pagos para Latinoamérica.',
    guide: '/docs/integrations-mercadopago',
    name: 'Mercado Pago',
    placeholder: '',
    warning: ''
  },
  {
    id: 'twocheckout',
    allow_reusable_use: false,
    allow_single_use: true,
    currencies: ['USD'],
    description: '2Checkout es la plataforma de monetización todo en uno que te ayuda a maximizar tus ingresos y facilita la recaudación de pagos globales digitales.',
    guide: '/docs/integrations-2checkout',
    name: '2Checkout',
    placeholder: '',
    warning: ''
  }
]